module.exports = __webpack_public_path__ + "static/img/toyota_bluetooth_2.f9f241c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/toyota_bluetooth_2.png
// module id = yXf2
// module chunks = 216